import {
  doc,
  getDoc,
  getDocs,
  collection,
  query,
  limit,
  addDoc,
  updateDoc,
  deleteDoc,
  startAfter,
  getCountFromServer,
  where,
} from "firebase/firestore";
import { db } from "config/firebase";

const getDocument = (id) => {
  return doc(db, "surveys", id);
};

export const getData = async (reference) => {
  if (reference) {
    const docSnap = await getDoc(reference);
    return docSnap.exists() ? { id: docSnap?.id, ...docSnap.data() } : null;
  }
  return null;
};

export const getSurveys = async (last, limitCount = 50) => {
  try {
    // Query to get the survey
    const q = last
      ? query(
          collection(db, "surveys"),
          startAfter(last),
          limit(limitCount),
        )
      : query(
          collection(db, "surveys"),
          limit(limitCount),
        );

    const documentSnapshots = await getDocs(q);

    // Get the last visible document
    const lastVisible =
      documentSnapshots.docs[documentSnapshots.docs.length - 1];

    const surveys = documentSnapshots.docs.map((doc) => {
      return { ...doc.data(), id: doc.id };
    });

    let totalSurveysCount = surveys.length;
    let counts = null;

    if (!last) {
      try {
        const [countSnapshot, finishedSnapshot] = await Promise.all([
          getCountFromServer(query(collection(db, "surveys"))),
          getCountFromServer(
            query(collection(db, "surveys"), where("type", "==", "finished"))
          ),
        ]);
        totalSurveysCount = countSnapshot.data().count;
        const finished = finishedSnapshot.data().count;
        const active = Math.max(0, totalSurveysCount - finished);
        counts = {
          total: totalSurveysCount,
          finished,
          active,
          pending: 0,
        };
      } catch (countErr) {
        console.warn("Failed to get survey count breakdown, using fallback", countErr);
        const countQuery = query(collection(db, "surveys"));
        const countSnapshot = await getCountFromServer(countQuery);
        totalSurveysCount = countSnapshot.data().count;
        counts = {
          total: totalSurveysCount,
          finished: 0,
          active: totalSurveysCount,
          pending: 0,
        };
      }
    }

    return { surveys, last: lastVisible, totalSurveysCount, counts };
  } catch (error) {
    console.error(`Error while getting surveys: ${error}`);
    return error;
  }
};

export const getSurveysLength = async () => {
  const countQuery = query(collection(db, "surveys"));
  const countSnapshot = await getCountFromServer(countQuery);
  const totalSurveysCount = countSnapshot.data().count;
  return totalSurveysCount;
};

export const getSurveyById = async (id) => {
  const docRef = getDocument(id);
  const docSnap = await getDoc(docRef);
  const lesson = docSnap.data();
  return docSnap.exists() ? { id: docSnap.id, ...lesson, reviewers: [] } : null;
};

export const createSurvey = async (survey) => {
  try {
    const newSurvey = await addDoc(collection(db, "surveys"), survey);
    return newSurvey;
  } catch (e) {
    console.error(`Error while creating survey ${e}`);
    return false;
  }
};

export const updateSurveys = async (id, data) => {
  try {
    await updateDoc(getDocument(id), data);
  } catch (e) {
    console.error(`Error while updating survey ${e}`);
    return false;
  }
};

export const deleteSurvey = async (id) => {
  try {
    await deleteDoc(getDocument(id));
  } catch (e) {
    console.error(`Error while deleting survey ${e}`);
    return false;
  }
};
